import { Component } from '@angular/core';

import { Observable, Subject } from '../util/rxjs';
import { FeedbackBarError, FeedbackBarService } from './feedback-bar.service';

@Component({
  selector: 'cp-feedback-bar',
  templateUrl: './feedback-bar.component.html',
  styleUrls: ['./feedback-bar.component.less']
})
export class FeedbackBarComponent {
  errors$: Observable<FeedbackBarError | undefined>;

  private hideStream = new Subject<undefined>();

  constructor(private feedbackBarService: FeedbackBarService) {
    this.errors$ = this.feedbackBarService.errors$
      .merge(this.hideStream)
      .switchMap(error => Observable.of(error).concat(Observable.of(undefined).delay(5000)))
      .startWith(undefined);
  }

  hide() {
    this.hideStream.next(undefined);
  }
}

